export default __webpack_public_path__ + "static/media/agradecimiento.65e44ae8.svg";